// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1KF9k","form":"styles_form__35yGp"};